/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined, LoadingOutlined } from '@ant-design/icons';
import { FormattedDate, FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { groupBy, isEmpty, maxBy, orderBy } from 'lodash';
import Table from 'components/Table';
import dayjs from 'utils/dayjs';
import { makeColumnFilteringProps } from '../../shared';
import ReactCardFlip from 'react-card-flip';

const { Column } = Table;

const UnconstrainedForecast = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const intl = useIntl();
    const [fetching, setFetching] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [isFlipped, setFlipped] = useState(false);
    const [graphData, setGraphData] = useState();
    const [selectedProperty, setSelectedProperty] = useState('');

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let forecastData;
        if (individualPropertyID) {
            const response = await statsService({
                token,
            }).getAccountManagementUnconstrainedForecast({ propertyID: individualPropertyID });
            forecastData = response?.data || [];
        } else {
            const response = await statsService({
                token,
            }).getAccountManagementUnconstrainedForecast();
            forecastData = response?.data || [];
        }
        if (!isEmpty(propertyUuids)) {
            forecastData = forecastData.filter(({ uuid }) => propertyUuids.includes(uuid));
        }
        setFullData(forecastData);
        const groupedByProperty = groupBy(forecastData, 'name');
        const groupedByPropertyWithMax = {};
        Object.entries(groupedByProperty).forEach(([propertyName, forecast]) => {
            const max = maxBy(forecast, 'percentageOver');
            groupedByPropertyWithMax[propertyName] = {
                ...max,
                numDays: forecast.length,
            };
        });
        setData(Object.values(groupedByPropertyWithMax));
        setFetching(false);
        setFetched(true);
    };

    useEffect(() => {
        loadData();
    }, [propertyUuids]);

    const handleFlip = (record) => {
        const propertyData = fullData.filter((d) => d.propertyID === record.propertyID);
        setSelectedProperty(record.name);
        setGraphData(
            orderBy(propertyData, [(item) => dayjs(item.stayDate).format('YYYY-MM-DD')], ['asc']).map((d) => ({
                stayDate: dayjs(d.stayDate).format('YYYY-MM-DD'),
                forecastRooms: d.forecastRooms,
                unconstrainedForecastRooms: d.unconstrainedForecastRooms,
                addedUnconstrainedRooms: d.unconstrainedForecastRooms - d.forecastRooms,
            })),
        );

        setFlipped(!isFlipped);
    };

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                {fetching && <LoadingOutlined style={{ marginRight: '8px' }} />}
                {!fetching && fetched && (
                    <>
                        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                            <div>
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '7px',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    <FormattedMessage {...messages.header} />
                                </div>
                                <Table
                                    dataSource={data}
                                    pagination={{
                                        pageSize: 31,
                                        hideOnSinglePage: true,
                                    }}
                                    rowKey="name"
                                    tableLayout="auto"
                                    size="small"
                                    scroll={{ y: 365 }}
                                    onRow={(record) => ({
                                        onClick: () => {
                                            handleFlip(record);
                                        },
                                    })}
                                >
                                    <Column
                                        width="30%"
                                        dataIndex="name"
                                        title={<FormattedMessage {...messages.nameColumnTitle} />}
                                        sorter={(a, b) => a.name.localeCompare(b.name)}
                                        {...makeColumnFilteringProps(data, 'name')}
                                    />
                                    <Column
                                        width="20%"
                                        align="center"
                                        dataIndex="stayDate"
                                        render={(value) => (
                                            <FormattedDate value={value} year="numeric" month="short" day="2-digit" />
                                        )}
                                        title={<FormattedMessage {...messages.stayDateColumnTitle} />}
                                        sorter={(a, b) => dayjs(a.stayDate).unix() - dayjs(b.stayDate).unix()}
                                    />
                                    <Column
                                        width="30%"
                                        align="center"
                                        dataIndex="percentageOver"
                                        title={<FormattedMessage {...messages.percentageColumnTitle} />}
                                        render={(value) => (
                                            <FormattedNumber
                                                value={value}
                                                minimumFractionDigits={2}
                                                maximumFractionDigits={2}
                                                style="percent"
                                            />
                                        )}
                                        sorter={(a, b) => a.percentageOver - b.percentageOver}
                                        defaultSortOrder="descend"
                                    />
                                    <Column
                                        width="20%"
                                        align="center"
                                        dataIndex="numDays"
                                        title={<FormattedMessage {...messages.daysColumnTitle} />}
                                        sorter={(a, b) => a.numDays - b.numDays}
                                    />
                                </Table>
                            </div>
                            <div onClick={handleFlip}>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        fontSize: '1.1em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {selectedProperty}
                                </div>

                                <ResponsiveContainer width="100%" height={500} className="card-content">
                                    <BarChart
                                        data={graphData}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                        onClick={handleFlip}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="stayDate" />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Bar
                                            dataKey="forecastRooms"
                                            stackId="a"
                                            fill="#82ca9d"
                                            name={intl.formatMessage(messages.graphRooms)}
                                        />
                                        <Bar
                                            dataKey="addedUnconstrainedRooms"
                                            stackId="a"
                                            fill="#e45567"
                                            name={intl.formatMessage(messages.graphExtraRooms)}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </ReactCardFlip>
                    </>
                )}
            </ScrollableBodyTall>
        </>
    );
};

UnconstrainedForecast.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default UnconstrainedForecast;
